import { getWishlistDisplayName } from '@/lib/wishlists/presentation'

export function useWishlistName() {
  return {
    getWishlistName: (name: string) => getWishlistDisplayName(name),
  }
}
